import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "exam-show-page" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = {
  key: 0,
  xs12: ""
}
const _hoisted_4 = {
  column: "",
  class: "mt-3 center-layout"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = { key: 0 }

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { checkMobile } from '../../utils/utils'
import ProgressRotate from '../atoms_molecules/ProgressRotate.vue'
import { ROUTER_NAME } from '../../router'
import { examGoalContext, goalPath } from '../../utils/exam_goal_context'
import ExamGoalReturnButton from '../atoms_molecules/ExamGoalReturnButton.vue'
import { LETTER_FORMAT } from '../../utils/constants'
import { useExam } from '../../composables/useExam'
import { headerState } from '../../stores/header'
import { footerState } from '../../stores/footer'
import { examTestState } from '../../stores/exam_test'
import { userState } from '../../stores/user'
import { examMyState } from '../../stores/exam_my'
import Exam from '../../models/exam'
import { PageModeType } from '../../types'
import ExamComponent from '../organisms/Exam.vue'
import SubPage from '../atoms_molecules/SubPage.vue'
import { getQueryString } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamTestShow',
  setup(__props) {

const route = useRoute()
const router = useRouter()

// Use composable for exam actions
const { startExam, continueExam, resultExam, gotoResult, gotoExam, gotoTest, reTest } = useExam()

const reRender = ref(Date().toString())
const mobile = ref(false)
const pageMode = ref<PageModeType>('main_page')
const subPageExam = ref<Exam | null>(null)

const isEmbed = computed(() => !!route.meta?.embed)

const footerMobile = {
  color: '#7DD420',
  show: true,
  default: {
    show: false
  },
  buttons: {
    show: true,
    items: []
  }
}

const allExams = computed(() => examMyState.list)
const exam = computed(() => examTestState.exam)
const redirectNotFoundPage = computed(() => examTestState.redirectNotFoundPage)
const user = computed(() => userState.user)
const schoolSetting = computed(() => headerState.schoolSetting)

// Type-safe computed properties for route query params
const userExamId = computed(() => getQueryString(route.query, 'user_exam_id'))
const currentExamId = computed(() => getQueryString(route.query, 'exam_id'))

const userExam = computed(() => {
  if (!userExamId.value) {
    return exam.value?.userExam
  }
  const found = exam.value?.userExams.find(item => item.id == parseInt(userExamId.value as string))
  return found
})

const headerNavTextColor = computed(() => {
  if (schoolSetting.value) {
    return schoolSetting.value.navTextColor
  }
})

const headerNavColor = computed(() => {
  if (schoolSetting.value) {
    return schoolSetting.value.navColor
  }
  return '#1976D2'
})

const hamburgerColor = computed(() => {
  if (schoolSetting.value) {
    return `color: ${schoolSetting.value.hamburgerColor}`
  }
  return 'color: white'
})

const toExamList = () => {
  if (user.value?.isGuestExamOnly) {
    location.href = `/exams/${route.params.examId}`
    return
  }

  // ゴールから開いたテストはゴールへ、テスト一覧から開いたテストはテスト一覧へ
  const goalContext = examGoalContext(route.params.examId as string)
  if (goalContext) {
    router.push(goalPath(goalContext))
    return
  }
  router.push({
    name: ROUTER_NAME.MY_EXAM_LIST
  })
}

const redirectToNotFoundPage = () => {
  router.push({
    name: ROUTER_NAME.NOT_FOUND
  })
}

const fetchExams = async () => {
  await examMyState.getMyExams()

  if (currentExamId.value) {
    const found = examMyState.list.find(item => item.id.toString() === currentExamId.value)
    if (found) {
      onShowHistories(found)
    }
  }
}

const onSwitchMode = (mode: PageModeType) => {
  pageMode.value = mode
  router.push({
    query: {
      ...route.query ?? {},
      exam_id: undefined
    }
  })
}

const onShowHistories = (examItem: Exam) => {
  pageMode.value = 'sub_page'
  subPageExam.value = examItem
  router.push({
    query: {
      ...route.query ?? {},
      exam_id: examItem.id.toString()
    }
  })
}

onMounted(() => {
  fetchExams()
  examTestState.requestExamTest(parseInt(route.params.examId as string), "last_child").then(() => {
    headerState.setTitle(exam.value!.name)
  })
  mobile.value = checkMobile()
  if (mobile.value) {
    footerState.setFooter(footerMobile as any)
  } else if (!isEmbed.value) {
    footerState.setFooterDefault()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Custom Header for Exam Detail - ẩn khi embed vào lesson "),
    (exam.value && !isEmbed.value)
      ? (_openBlock(), _createBlock(_component_v_toolbar, {
          key: 0,
          color: headerNavColor.value,
          class: "exam-header",
          flat: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_btn, {
                icon: true,
                variant: "text",
                onClick: toExamList,
                style: _normalizeStyle(hamburgerColor.value)
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["style"]),
              _createVNode(_component_v_toolbar_title, {
                class: "header-title",
                style: _normalizeStyle({ 'color': headerNavTextColor.value })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(exam.value.name), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["style"])
            ]),
            _createVNode(_component_v_spacer),
            _createVNode(ExamGoalReturnButton, {
              class: "me-3",
              "exam-id": _unref(route).params.examId as string,
              variant: "tonal"
            }, null, 8 /* PROPS */, ["exam-id"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["color"]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Main Content "),
    _createVNode(SubPage, {
      pageMode: pageMode.value,
      onSwitchMode: onSwitchMode
    }, {
      main_page: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          class: "d-flex question-screen justify-content-center flex-wrap",
          key: reRender.value
        }, [
          (exam.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("img", {
                      src: exam.value.image.url,
                      class: "flex xs8 sm8 lg3 exam-thumbnail"
                    }, null, 8 /* PROPS */, _hoisted_5),
                    _createElementVNode("h1", _hoisted_6, _toDisplayString(exam.value.name), 1 /* TEXT */),
                    _createElementVNode("p", null, _toDisplayString(exam.value.description), 1 /* TEXT */),
                    (userExam.value && exam.value.isDone(userExam.value) && userExam.value.isWaitingScoreCheck)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            rounded: "",
                            color: "warning"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('exam_result.check_score')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]))
                      : (userExam.value && exam.value.isDone(userExam.value))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "cursor-pointer",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(gotoResult)(exam.value, userExam.value)))
                          }, [
                            _createVNode(ExamComponent, {
                              exam: exam.value,
                              isMine: true,
                              list: allExams.value,
                              onlyAction: true,
                              userExam: userExam.value,
                              schoolSetting: schoolSetting.value,
                              onFetchList: fetchExams,
                              onShowHistories: onShowHistories
                            }, null, 8 /* PROPS */, ["exam", "list", "userExam", "schoolSetting"])
                          ]))
                        : (!userExam.value || !exam.value.isStarted(userExam.value))
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 2,
                              rounded: "",
                              color: "primary",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(startExam)(exam.value, userExam.value))),
                              cytag: "start-test"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('exam_show.start')), 1 /* TEXT */)
                              ]),
                              _: 1 /* STABLE */
                            }))
                          : (userExam.value && exam.value.isTestTimeOver(userExam.value))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createVNode(_component_v_btn, {
                                  rounded: "",
                                  color: "red",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(resultExam)(exam.value, userExam.value))),
                                  cytag: "over-test"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('exam_show.time_over')), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }),
                                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mt-2 text-red" }, "このテストは時間を超過しています。", -1 /* CACHED */))
                              ], 64 /* STABLE_FRAGMENT */))
                            : (userExam.value)
                              ? (_openBlock(), _createBlock(_component_v_btn, {
                                  key: 4,
                                  rounded: "",
                                  color: "primary",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(continueExam)(exam.value, userExam.value))),
                                  cytag: "continue-test"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('exam_show.continue')), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }))
                              : _createCommentVNode("v-if", true)
                  ])
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      ]),
      sub_page: _withCtx(() => [
        (subPageExam.value)
          ? (_openBlock(), _createBlock(ExamComponent, {
              key: 0,
              exam: subPageExam.value,
              isMine: true,
              list: allExams.value,
              schoolSetting: schoolSetting.value,
              onFetchList: fetchExams
            }, null, 8 /* PROPS */, ["exam", "list", "schoolSetting"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["pageMode"])
  ]))
}
}

})